import React, { lazy } from "react";

const FbaInboundNew = lazy(() => import("../../containers/fbaInbound/index"));
const StepGatedSku = lazy(() =>
  import("../../containers/fbaInbound/component/stepGatedSku")
);

export const FBA_INBOUND_NEW_ROUTES = [
  {
    path: "/fba-inbound-new",
    component: <FbaInboundNew />,
    group: "FBA Inbound",
    reducer: [],
  },
  {
    path: "/fba-inbound-new/step-gated-sku/:batchId",
    component: <StepGatedSku />,
    group: "FBA Inbound",
    reducer: [],
  },
];
